(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(85038);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PageSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(55027);
// EXTERNAL MODULE: ./src/components/PageSection/svg/CurvedSvg.tsx
var CurvedSvg = __webpack_require__(68122);
;// CONCATENATED MODULE: ./src/components/PageSection/CurvedDivider.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  z-index: ",
        ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-0"
})(_templateObject(), function(param) {
    var theme = param.theme, dividerFill = param.dividerFill;
    if (theme.isDark) {
        return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || "none";
    }
    return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || "none";
}, function(param) {
    var index = param.index;
    return index;
});
var ComponentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-1"
})(_templateObject1(), function(param) {
    var index = param.index;
    return index + 1;
});
var CurvedDivider = function(param) {
    var index = param.index, dividerPosition = param.dividerPosition, dividerComponent = param.dividerComponent, concave = param.concave, clipFill = param.clipFill, dividerFill = param.dividerFill;
    var showConvexTop = dividerPosition === "top" && !concave;
    var showConvexBottom = dividerPosition === "bottom" && !concave;
    var showConcaveTop = dividerPosition === "top" && concave;
    var showConcaveBottom = dividerPosition === "bottom" && concave;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        index: index,
        dividerFill: dividerFill,
        children: [
            dividerComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper, {
                index: index,
                children: dividerComponent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConcaveTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConcaveTop */.n6, {
                        clipFill: clipFill
                    }),
                    showConcaveBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConcaveBottom */.CT, {
                        clipFill: clipFill
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConvexTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConvexTop */.Z5, {
                        clipFill: clipFill
                    }),
                    showConvexBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConvexBottom */.kZ, {
                        clipFill: clipFill
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PageSection_CurvedDivider = (CurvedDivider);

;// CONCATENATED MODULE: ./src/components/PageSection/index.tsx




function PageSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  align-items: center;\n  z-index: ",
        ";\n  background: ",
        ";\n  padding: ",
        ";\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n"
    ]);
    PageSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: auto;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  ",
        " {\n    padding-top: 32px;\n    padding-bottom: 32px;\n  }\n\n  ",
        " {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n"
    ]);
    PageSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var BackgroundColor = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-52796267-0"
})(PageSection_templateObject(), function(param) {
    var index = param.index;
    return index - 1;
}, function(param) {
    var background = param.background, theme = param.theme;
    return background || theme.colors.background;
}, function(param) {
    var padding = param.padding;
    return padding;
});
var ChildrenWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-52796267-1"
})(PageSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PageSection = function(_param) {
    var children = _param.children, background = _param.background, svgFill = _param.svgFill, _index = _param.index, index = _index === void 0 ? 1 : _index, dividerComponent = _param.dividerComponent, _dividerPosition = _param.dividerPosition, dividerPosition = _dividerPosition === void 0 ? "bottom" : _dividerPosition, _hasCurvedDivider = _param.hasCurvedDivider, hasCurvedDivider = _hasCurvedDivider === void 0 ? true : _hasCurvedDivider, _concaveDivider = _param.concaveDivider, concaveDivider = _concaveDivider === void 0 ? false : _concaveDivider, clipFill = _param.clipFill, dividerFill = _param.dividerFill, containerProps = _param.containerProps, innerProps = _param.innerProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "background",
        "svgFill",
        "index",
        "dividerComponent",
        "dividerPosition",
        "hasCurvedDivider",
        "concaveDivider",
        "clipFill",
        "dividerFill",
        "containerProps",
        "innerProps"
    ]);
    var padding = (0,react.useMemo)(function() {
        // No curved divider
        if (!hasCurvedDivider) {
            return "48px 0";
        }
        // Bottom curved divider
        // Less bottom padding, as the divider is present there
        if (dividerPosition === "bottom") {
            return "48px 0 14px";
        }
        // Top curved divider
        // Less top padding, as the divider is present there
        if (dividerPosition === "top") {
            return "14px 0 48px";
        }
        return "48px 0";
    }, [
        dividerPosition,
        hasCurvedDivider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, containerProps), {
        children: [
            hasCurvedDivider && dividerPosition === "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundColor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                background: background,
                index: index,
                padding: padding
            }, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerProps), {
                    children: children
                }))
            })),
            hasCurvedDivider && dividerPosition === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            })
        ]
    }));
};
/* harmony default export */ var components_PageSection = (PageSection);


/***/ }),

/***/ 68122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ ConcaveBottom; },
/* harmony export */   "Z5": function() { return /* binding */ ConvexTop; },
/* harmony export */   "kZ": function() { return /* binding */ ConvexBottom; },
/* harmony export */   "n6": function() { return /* binding */ ConcaveTop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44850);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 20px;\n  clip-path: url(",
        ");\n\n  background: ",
        ";\n\n  & svg {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var sharedStyles = function(theme, clipPath, clipFill) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), clipPath, function() {
        if (theme.isDark) {
            return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.dark) || (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
        }
        return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
    });
};
var ConcaveContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f0d6319c-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConcaveCurve" ? "translate(0, -13px)" : "translate(0, 1px)";
});
var ConvexContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f0d6319c-1"
})(_templateObject2(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConvexCurve" ? "translate(0, -13px)" : "translate(0, -1px)";
});
var ConvexTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#topConvexCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "topConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C 0.75 0, .25 0, 0 1 Z"
                    })
                })
            })
        })
    });
};
var ConvexBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConvexCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "bottomConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#topConcaveCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "topConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConcaveCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "bottomConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C .75 0.1, .25 0.1, 0 1 Z"
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 27892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useSlowRefreshEffect; },
/* harmony export */   "a": function() { return /* binding */ useFastRefreshEffect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3862);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8100);
/* harmony import */ var _useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64011);





var EMPTY_ARRAY = [];
function useFastRefreshEffect(effect, deps) {
    var chainId = (0,_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().chainId;
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)([
        config_constants__WEBPACK_IMPORTED_MODULE_0__/* .FAST_INTERVAL */ .sR,
        "blockNumber",
        chainId
    ]), _data = ref.data, data = _data === void 0 ? 0 : _data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(effect.bind(null, data), [
        data
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(deps || EMPTY_ARRAY)));
}
function useSlowRefreshEffect(effect, deps) {
    var chainId = (0,_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().chainId;
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)([
        config_constants__WEBPACK_IMPORTED_MODULE_0__/* .SLOW_INTERVAL */ .KI,
        "blockNumber",
        chainId
    ]), _data = ref.data, data = _data === void 0 ? 0 : _data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(effect.bind(null, data), [
        data
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(deps || EMPTY_ARRAY)));
}


/***/ }),

/***/ 85038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/PageSection/index.tsx + 1 modules
var PageSection = __webpack_require__(76736);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(83559);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 1 modules
var src = __webpack_require__(40687);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(95963);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(41144);
// EXTERNAL MODULE: ./src/config/abi/erc20.json
var erc20 = __webpack_require__(93324);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(27892);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 5 modules
var tokens_src = __webpack_require__(32521);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
;// CONCATENATED MODULE: ./src/views/Home/components/Hero.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  bottom: 0px;\n  left: 0px;\n  background-image: url('/images/home/bg.jpg');\n  background-size: cover;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var BgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f9df087-0"
})(_templateObject());
var Hero = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,react.useState)(0), liteSupply = ref[0], setLiteSupply = ref[1];
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function() {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, totalSupply;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.t0 = _sliced_to_array/* default */.Z;
                            _ctx.next = 3;
                            return (0,multicall/* multicallv2 */.v)({
                                abi: erc20,
                                calls: [
                                    {
                                        address: tokens_src/* CAKE */.cr[src/* ChainId.BSC */.a_.BSC].address,
                                        name: "totalSupply"
                                    }
                                ],
                                chainId: src/* ChainId.BSC */.a_.BSC
                            });
                        case 3:
                            _ctx.t1 = _ctx.sent;
                            ref = (0, _ctx.t0)(_ctx.t1, 1);
                            totalSupply = ref[0];
                            setLiteSupply((0,formatBalance/* getBalanceNumber */.mW)(new (bignumber_default())(totalSupply || bigNumber/* BIG_ZERO */.HW)));
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        fetch();
    }, []);
    var price = (0,useBUSDPrice/* usePriceByPairs */.GB)(tokens_src/* USDT */.AA[src/* ChainId.BSC */.a_.BSC], tokens_src/* CAKE */.cr[src/* ChainId.BSC */.a_.BSC]);
    var liteSupplyString = liteSupply ? (0,formatBalance/* default */.ZP)(liteSupply) : "-";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgWrapper, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                position: "relative",
                flexDirection: "column",
                alignItems: [
                    "center",
                    null,
                    null,
                    "center"
                ],
                justifyContent: "center",
                mt: [
                    "30px",
                    null,
                    "30px"
                ],
                mb: [
                    "30px",
                    "30px",
                    null,
                    "250px"
                ],
                id: "homepage-hero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: [
                                    "25px",
                                    null,
                                    null,
                                    "55px"
                                ],
                                fontWeight: 800,
                                color: "primary",
                                children: "LITESWAP PROTOCOL"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: [
                                    "14px",
                                    null,
                                    null,
                                    "42px"
                                ],
                                fontWeight: 400,
                                children: "Bringing a Comprehensive Ecosystem"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: [
                            "column",
                            null,
                            null,
                            "row"
                        ],
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        borderRadius: [
                            "10px",
                            null,
                            null,
                            "16px"
                        ],
                        mt: [
                            "20px",
                            null,
                            "40px"
                        ],
                        py: [
                            "30px",
                            null,
                            null,
                            "53px"
                        ],
                        width: [
                            "100%",
                            null,
                            null,
                            "80%"
                        ],
                        style: {
                            background: "rgba(255, 255, 255, 0.04)",
                            backdropFilter: "blur(10px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                style: {
                                    gap: "10px"
                                },
                                py: [
                                    "5px",
                                    null,
                                    null,
                                    "10px"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: [
                                            "12px",
                                            null,
                                            null,
                                            "22px"
                                        ],
                                        fontWeight: 200,
                                        color: "textSubtle",
                                        children: "Total Supply"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: [
                                            "14px",
                                            null,
                                            null,
                                            "28px"
                                        ],
                                        fontWeight: 800,
                                        children: liteSupply
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                style: {
                                    gap: "10px"
                                },
                                py: [
                                    "5px",
                                    null,
                                    null,
                                    "10px"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: [
                                            "12px",
                                            null,
                                            null,
                                            "22px"
                                        ],
                                        fontWeight: 200,
                                        color: "textSubtle",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: [
                                            "14px",
                                            null,
                                            null,
                                            "28px"
                                        ],
                                        fontWeight: 800,
                                        children: price ? "$".concat(price === null || price === void 0 ? void 0 : price.toFixed(2)) : "-"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        mt: "42px",
                        as: "a",
                        href: "/swap",
                        variant: "secondary",
                        children: "Launch App"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(53629);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
;// CONCATENATED MODULE: ./src/views/Home/components/CompositeImage.tsx

function CompositeImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(",
        ", ",
        ");\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    CompositeImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-height: ",
        ";\n\n  & :nth-child(2) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n\n  & :nth-child(5) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0s;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        ";\n  visibility: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  img {\n    max-height: 100%;\n    width: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var floatingAnim = function(x, y) {
    return (0,styled_components_browser_esm/* keyframes */.F4)(CompositeImage_templateObject(), x, y);
};
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-dd92527b-0"
})(_templateObject1(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
}, floatingAnim("3px", "15px"), floatingAnim("5px", "10px"), floatingAnim("6px", "5px"), floatingAnim("4px", "12px"));
var DummyImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-dd92527b-1"
})(_templateObject2(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
});
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-dd92527b-2"
})(_templateObject3());
var Resolution;
(function(Resolution) {
    Resolution["MD"] = "1.5x";
    Resolution["LG"] = "2x";
})(Resolution || (Resolution = {}));
var getImageUrl = function(base, imageSrc, resolution) {
    var extension = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".png";
    return "".concat(base).concat(imageSrc).concat(resolution ? "@".concat(resolution).concat(extension) : extension);
};
var getSrcSet = function(base, imageSrc) {
    var extension = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".png";
    return "".concat(getImageUrl(base, imageSrc, undefined, extension), " 512w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.MD, extension), " 768w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.LG, extension), " 1024w,");
};
var CompositeImage = function(param) {
    var path = param.path, attributes = param.attributes, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? "512px" : _maxHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        maxHeight: maxHeight,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyImg, {
                srcSet: getSrcSet(path, attributes[0].src, ".webp"),
                maxHeight: maxHeight,
                loading: "lazy",
                decoding: "async",
                onError: function(e) {
                    var fallbackSrcSet = getSrcSet(path, attributes[0].src);
                    if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                        // eslint-disable-next-line no-param-reassign
                        e.currentTarget.srcset = fallbackSrcSet;
                    } else {
                        var fallbackSrc = getImageUrl(path, attributes[0].src);
                        if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.srcset = "";
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.src = fallbackSrc;
                        }
                    }
                }
            }),
            attributes.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        srcSet: getSrcSet(path, image.src, ".webp"),
                        alt: image.alt,
                        onError: function(e) {
                            var fallbackSrcSet = getSrcSet(path, image.src);
                            if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                                // eslint-disable-next-line no-param-reassign
                                e.currentTarget.srcset = fallbackSrcSet;
                            } else {
                                var fallbackSrc = getImageUrl(path, image.src);
                                if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.srcset = "";
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.src = fallbackSrc;
                                }
                            }
                        }
                    })
                }, image.src);
            })
        ]
    });
};
/* harmony default export */ var components_CompositeImage = (CompositeImage);

;// CONCATENATED MODULE: ./src/views/Home/components/SalesSection1.tsx







var SalesSection = function() {
    var theme = (0,useTheme/* default */.ZP)().theme;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var images = {
        path: "/images/home/trade/",
        attributes: [
            {
                src: "icon1",
                alt: t("BNB token")
            },
            {
                src: "icon2",
                alt: t("BNB token")
            },
            {
                src: "icon3",
                alt: t("BNB token")
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: [
                "column-reverse",
                null,
                null,
                "row"
            ],
            alignItems: "center",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    flex: "1",
                    mr: [
                        null,
                        null,
                        null,
                        "64px"
                    ],
                    alignSelf: [
                        "flex-start",
                        null,
                        null,
                        "center"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: [
                                "20px",
                                null,
                                null,
                                "38px"
                            ],
                            color: "#060602",
                            mb: "10px",
                            children: "LiteSwap Ecosystem"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: [
                                "12px",
                                null,
                                null,
                                "22px"
                            ],
                            color: theme.colors.primary,
                            children: "Keep growing, Keep moving, Keep building"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: [
                                "12px",
                                null,
                                null,
                                "22px"
                            ],
                            color: theme.colors.textSubtle,
                            mb: "24px",
                            children: "Integrates many excellent tools"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                mr: "16px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                    to: "/launchpad",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "card",
                                        bold: true,
                                        fontSize: "16px",
                                        children: "Explore all"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    height: [
                        "192px",
                        null,
                        null,
                        "300px"
                    ],
                    width: [
                        "192px",
                        null,
                        null,
                        "350px"
                    ],
                    mb: [
                        "24px",
                        null,
                        null,
                        "0"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,_object_spread/* default */.Z)({}, images))
                })
            ]
        })
    });
};
/* harmony default export */ var SalesSection1 = (SalesSection);

;// CONCATENATED MODULE: ./src/views/Home/components/SalesSection2.tsx






var SalesSection2_SalesSection = function() {
    var theme = (0,useTheme/* default */.ZP)().theme;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var images = {
        path: "/images/home/trade/",
        attributes: [
            {
                src: "icon4",
                alt: t("BNB token")
            },
            {
                src: "icon5",
                alt: t("USDT token")
            },
            {
                src: "icon6",
                alt: t("BCC token")
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: [
                "column-reverse",
                null,
                null,
                "row-reverse"
            ],
            alignItems: [
                "center",
                null,
                null,
                "center"
            ],
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    flex: "1",
                    ml: [
                        null,
                        null,
                        null,
                        "64px"
                    ],
                    alignSelf: [
                        "flex-start",
                        null,
                        null,
                        "center"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: [
                                "20px",
                                null,
                                null,
                                "32px"
                            ],
                            fontWeight: 800,
                            color: "",
                            children: "Born in the community"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: [
                                "20px",
                                null,
                                null,
                                "32px"
                            ],
                            fontWeight: 800,
                            color: "",
                            mb: "10px",
                            children: "Governed by the community"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: [
                                "12px",
                                null,
                                null,
                                "22px"
                            ],
                            color: theme.colors.textSubtle,
                            mb: "24px",
                            children: "The LiteSwap is managed by a global community of XLITE holders and delegates."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                mr: "16px",
                                variant: "secondary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "card",
                                    bold: true,
                                    fontSize: "16px",
                                    children: "GOT xLITE"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    height: [
                        "192px",
                        null,
                        null,
                        "300px"
                    ],
                    width: [
                        "192px",
                        null,
                        null,
                        "350px"
                    ],
                    mb: [
                        "24px",
                        null,
                        null,
                        "0"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,_object_spread/* default */.Z)({}, images))
                })
            ]
        })
    });
};
/* harmony default export */ var SalesSection2 = (SalesSection2_SalesSection);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx

function Home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n\n  ",
        " {\n    padding-top: 48px;\n  }\n"
    ]);
    Home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var StyledHeroSection = (0,styled_components_browser_esm/* default */.ZP)(PageSection/* default */.Z).withConfig({
    componentId: "sc-6392f2bd-0"
})(Home_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Home = function() {
    var HomeSectionContainerStyles = {
        margin: "0",
        width: "100%",
        maxWidth: "968px"
    };
    var router = (0,next_router.useRouter)();
    router.replace("/swap");
    return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroSection, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                index: 1,
                hasCurvedDivider: false,
                mt: "-1px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: "#fff",
                index: 2,
                hasCurvedDivider: false,
                mt: "-1px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesSection1, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: "url(/images/home/bg2.jpg)",
                index: 3,
                hasCurvedDivider: false,
                mt: "-1px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesSection2, {})
            })
        ]
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl, liteSupply = param.liteSupply, marketCap = param.marketCap;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl,
                liteSupply: liteSupply,
                marketCap: marketCap
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {})
    });
};
IndexPage.chains = [];
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);